import React, { memo } from 'react'
import { Card, Col, ProgressBar } from 'react-bootstrap'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { connect, useDispatch } from 'react-redux'

import {
  formatVolume10,
  StringToInt,
  numberFormat,
  colorFix,
  colorByChange,
} from 'utils'

import * as _ from 'lodash'
import styled from 'styled-components'
import { makeGetAnalSTMBActive } from 'lib/selector'
import { analStockMBActiveRequest } from 'containers/market/actions'

const StyleLS = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: auto 115px;
  gap: 4px;
  background: ${(props) => (props.theme === 'dark' ? '#1c192c' : '')};
`
function usePrevious(value) {
  const ref = React.useRef()

  React.useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}

function PanelStockTradeHistory(props) {
  const dispatch = useDispatch()
  const { stockDetail, topShow, analStMBActive, t, theme, symActive } = props

  const preSymActive = usePrevious(symActive)

  const stockRef = React.useRef(null)

  React.useEffect(() => {
    const timer = setInterval(() => {
      getMatchPrice()
    }, 10 * 1000)

    return () => {
      if (timer) clearInterval(timer)
    }
  }, [])

  React.useEffect(() => {
    if (symActive && !_.isEqual(symActive, preSymActive)) {
      stockRef.current = symActive
      getMatchPrice()
    }
  }, [symActive])

  function getMatchPrice() {
    console.log(stockRef.current)
    if (!stockRef.current) return

    dispatch(analStockMBActiveRequest(stockRef.current))
  }

  function renderMax(volBuy, volSell, volActiveQtty, _maxVolBS) {
    const _volMax =
      _maxVolBS.BuyActiveQtty +
      _maxVolBS.SellActiveQtty +
      _maxVolBS.NoneActiveQtty
    const _totalVol = volBuy + volSell + volActiveQtty
    const _perVol = (_totalVol * 100) / _volMax
    // const _total = volBuy + volSell + Math.abs(volBuy - volSell);
    console.log(_perVol, _totalVol, _maxVolBS)
    const perBuy = (volBuy * 100) / _totalVol
    const perSell = (volSell * 100) / _totalVol

    console.log(perBuy, perSell, _perVol)

    return (
      <div style={{ width: `${_perVol}%` }} className="frame-per">
        <div style={{ width: `${perBuy}%` }} className="frame-per-buy"></div>
        <div
          style={{ width: `${perSell}%` }}
          className="frame-per-sell mr-auto"
        ></div>
        {/* <div
          style={{ width: `${100 - perBuy - perSell}%` }}
          className="frame-per-other"
        ></div> */}
      </div>
    )
  }

  const totalBV =
    stockDetail &&
    StringToInt(stockDetail.BuyAmount1) +
      StringToInt(stockDetail.BuyAmount2) +
      StringToInt(stockDetail.BuyAmount3)
  const totalOV =
    stockDetail &&
    StringToInt(stockDetail.SellAmount1) +
      StringToInt(stockDetail.SellAmount2) +
      StringToInt(stockDetail.SellAmount3)

  const perBV1 =
    stockDetail && ~~((StringToInt(stockDetail.BuyAmount1) * 100) / totalBV)
  const perBV2 =
    stockDetail && ~~((StringToInt(stockDetail.BuyAmount2) * 100) / totalBV)
  const perBV3 =
    stockDetail && ~~((StringToInt(stockDetail.BuyAmount3) * 100) / totalBV)

  const perOV1 =
    stockDetail && ~~((StringToInt(stockDetail.SellAmount1) * 100) / totalOV)
  const perOV2 =
    stockDetail && ~~((StringToInt(stockDetail.SellAmount2) * 100) / totalOV)
  const perOV3 =
    stockDetail && ~~((StringToInt(stockDetail.SellAmount3) * 100) / totalOV)

  const perBV =
    totalBV + totalOV === 0
      ? 50
      : stockDetail && ~~((totalBV * 100) / (totalBV + totalOV))

  const _house = new Date().getHours()
  const _min = new Date().getMinutes()

  const _maxVolBS = _.maxBy(
    analStMBActive,
    (o) => o.BuyActiveQtty + o.SellActiveQtty + o.NoneActiveQtty
  )

  // log(topShow, _maxVolBS);
  // log(stockDetail);

  console.log(theme)

  return (
    <>
      <div className={'w-100 d-flex analysis-trade-his mt-2 ' + theme}>
        <Col style={{ padding: '0', borderRight: '1px solid #312E3F' }}>
          <Card>
            <Card.Body className="p-0">
              <table className="table table-borderless">
                <thead>
                  <tr>
                    <th
                      style={{ height: '15px' }}
                      className="text-right fz-12 fw-500 py-0"
                    >
                      {t('algo.ptcp.txt-Best-bid')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      className={
                        'position-relative rtl ' +
                        (stockDetail
                          ? colorFix(
                              stockDetail.BuyPrice1,
                              stockDetail.RefPrice,
                              stockDetail.CeilingPrice,
                              stockDetail.FloorPrice,
                              stockDetail.RefPrice
                            )
                          : '')
                      }
                      style={{
                        padding: '0.1rem 0 0.1rem 0.1rem',
                        borderBottom: '1px solid #312E3F',
                      }}
                    >
                      <ProgressBar variant="info" now={perBV1} />
                      <span className="per-vol">
                        {stockDetail && formatVolume10(stockDetail.BuyAmount1)}
                      </span>
                      <span className="per-price">
                        {stockDetail &&
                          ((!stockDetail.BuyPrice1 ||
                            stockDetail.BuyPrice1 == 0) &&
                          _house === 9 &&
                          _min <= 15
                            ? 'ATO'
                            : (!stockDetail.BuyPrice1 ||
                                stockDetail.BuyPrice1 == 0) &&
                              _house === 14 &&
                              _min >= 30 &&
                              _min <= 45
                            ? 'ATC'
                            : numberFormat(stockDetail.BuyPrice1, 2))}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td
                      className={
                        'position-relative rtl ' +
                        (stockDetail
                          ? colorFix(
                              stockDetail.BuyPrice2,
                              stockDetail.RefPrice,
                              stockDetail.CeilingPrice,
                              stockDetail.FloorPrice,
                              stockDetail.RefPrice
                            )
                          : '')
                      }
                      style={{
                        padding: '0.1rem 0 0.1rem 0.1rem',
                        borderBottom: '1px solid #312E3F',
                      }}
                    >
                      <ProgressBar variant="info" now={perBV2} />
                      <span className="per-vol">
                        {stockDetail && formatVolume10(stockDetail.BuyAmount2)}
                      </span>
                      <span className="per-price">
                        {stockDetail && numberFormat(stockDetail.BuyPrice2, 2)}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td
                      className={
                        'position-relative rtl ' +
                        (stockDetail
                          ? colorFix(
                              stockDetail.BuyPrice3,
                              stockDetail.RefPrice,
                              stockDetail.CeilingPrice,
                              stockDetail.FloorPrice,
                              stockDetail.RefPrice
                            )
                          : '')
                      }
                      style={{
                        padding: '0.1rem 0 0.1rem 0.1rem',
                      }}
                    >
                      <span className="per-price">
                        {stockDetail && numberFormat(stockDetail.BuyPrice3, 2)}
                      </span>
                      <ProgressBar variant="info" now={perBV3} />
                      <span className="per-vol">
                        {stockDetail && formatVolume10(stockDetail.BuyAmount3)}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Card.Body>
          </Card>
        </Col>
        <Col style={{ padding: '0' }}>
          <Card>
            <Card.Body className="p-0">
              <table className="table table-borderless">
                <thead>
                  <tr>
                    <th
                      style={{ height: '15px' }}
                      className="text-left fz-12 fw-500 py-0"
                    >
                      {t('algo.ptcp.txt-Best-ask')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      className={
                        'position-relative ' +
                        (stockDetail
                          ? colorFix(
                              stockDetail.SellPrice1,
                              stockDetail.RefPrice,
                              stockDetail.CeilingPrice,
                              stockDetail.FloorPrice,
                              stockDetail.RefPrice
                            )
                          : '')
                      }
                      style={{
                        padding: '0.1rem 0.1rem 0.1rem 0',
                        borderBottom: '1px solid #312E3F',
                      }}
                    >
                      <ProgressBar variant="danger" now={perOV1} />
                      <span className="per-vol">
                        {stockDetail && formatVolume10(stockDetail.SellAmount1)}
                      </span>
                      <span className="per-price" style={{ left: '5px' }}>
                        {stockDetail &&
                          ((!stockDetail.SellPrice1 ||
                            stockDetail.SellPrice1 == 0) &&
                          _house === 9 &&
                          _min <= 15
                            ? 'ATO'
                            : (!stockDetail.SellPrice1 ||
                                stockDetail.SellPrice1 == 0) &&
                              _house === 14 &&
                              _min >= 30 &&
                              _min <= 45
                            ? 'ATC'
                            : numberFormat(stockDetail.SellPrice1, 2))}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td
                      className={
                        'position-relative ' +
                        (stockDetail
                          ? colorFix(
                              stockDetail.SellPrice2,
                              stockDetail.RefPrice,
                              stockDetail.CeilingPrice,
                              stockDetail.FloorPrice,
                              stockDetail.RefPrice
                            )
                          : '')
                      }
                      style={{
                        padding: '0.1rem 0.1rem 0.1rem 0',
                        borderBottom: '1px solid #312E3F',
                      }}
                    >
                      <span className="per-price" style={{ left: '5px' }}>
                        {stockDetail && numberFormat(stockDetail.SellPrice2, 2)}
                      </span>
                      <ProgressBar variant="danger" now={perOV2} />
                      <span className="per-vol">
                        {stockDetail && formatVolume10(stockDetail.SellAmount2)}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td
                      className={
                        'position-relative ' +
                        (stockDetail
                          ? colorFix(
                              stockDetail.SellPrice3,
                              stockDetail.RefPrice,
                              stockDetail.CeilingPrice,
                              stockDetail.FloorPrice,
                              stockDetail.RefPrice
                            )
                          : '')
                      }
                      style={{
                        padding: '0.1rem 0.1rem 0.1rem 0',
                      }}
                    >
                      <span className="per-price" style={{ left: '5px' }}>
                        {stockDetail && numberFormat(stockDetail.SellPrice3, 2)}
                      </span>
                      <ProgressBar variant="danger" now={perOV3} />
                      <span className="per-vol">
                        {stockDetail && formatVolume10(stockDetail.SellAmount3)}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Card.Body>
          </Card>
        </Col>
      </div>
      <div
        className="d-flex w-100"
        style={{ paddingRight: '12px', marginTop: '5px' }}
      >
        <span className="mr-auto txt-content fz-12 fw-500">
          {t('algo.ptcp.txt-Matched-details')}
        </span>
        <span className="txt-content fz-12 fw-500">
          {t('algo.ptcp.txt-Matched-analysis')}
        </span>
      </div>
      <StyleLS theme={theme}>
        <PerfectScrollbar
          style={{ height: 'calc(100vh - 355px)', marginRight: '-5px' }}
        >
          <div
            className="w-100 flex-column"
            style={{ paddingRight: '5px', marginTop: '5px' }}
          >
            <table className="table table-borderless tbl-trade-his">
              <tbody>
                {topShow &&
                  topShow.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center txt-content fz-10">
                        {item.Time}
                      </td>
                      <td
                        className={
                          'text-left txt-content fz-10 ' +
                          colorByChange(item.PriceChange)
                        }
                      >
                        {numberFormat(item.MatchPrice, 2)}
                      </td>
                      <td
                        className={
                          'text-right txt-content fz-10 ' +
                          colorByChange(item.PriceChange)
                        }
                      >
                        {formatVolume10(item.MatchVolume / 10)}
                      </td>
                      <td
                        className={
                          'text-center txt-content fz-10 ' +
                          (item?.OrderType === 'S' ? 'd' : 'i')
                        }
                      >
                        {item.OrderType === 'S'
                          ? 'B'
                          : item.OrderType === 'B'
                          ? 'M'
                          : ''}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </PerfectScrollbar>
        <PerfectScrollbar
          style={{ height: 'calc(100vh - 355px)', marginRight: '-5px' }}
        >
          <div
            className="w-100 flex-column"
            style={{ paddingRight: '5px', marginTop: '5px' }}
          >
            <table className="table table-borderless tbl-trade-his">
              <tbody>
                {analStMBActive &&
                  analStMBActive.map((item, index) => (
                    <tr key={index}>
                      <td
                        className={
                          'text-center txt-content fz-10 ' +
                          colorByChange(item.MatchPrice - stockDetail?.RefPrice)
                        }
                        style={{ width: '45px' }}
                      >
                        {numberFormat(item.MatchPrice, 2)}
                      </td>
                      <td style={{ width: '70px' }}>
                        {renderMax(
                          item.BuyActiveQtty,
                          item.SellActiveQtty,
                          item.NoneActiveQtty,
                          _maxVolBS
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </PerfectScrollbar>
      </StyleLS>

      <div
        className="px-1 progress-total"
        style={{ marginBottom: '4px', marginTop: '5px' }}
      >
        <ProgressBar variant="success" now={perBV} />
      </div>
      <div
        className="d-flex w-100"
        style={{ paddingRight: '12px', marginTop: '5px' }}
      >
        <span className="mr-auto txt-content fz-12 fw-500">
          {t('algo.ptcp.txt-Active-buy-vol')}
        </span>
        <span className="fz-12 fw-500 i">{`${formatVolume10(
          !!topShow.length ? topShow[0].TotalBuyVolume / 10 : 0
        )}  `}</span>
        <span className="fz-12 fw-500 i ml-2">{t('algo.ptcp.txt-B')}</span>
      </div>
      <div
        className="d-flex w-100"
        style={{ paddingRight: '12px', marginTop: '12px' }}
      >
        <span className="mr-auto txt-content fz-12 fw-500">
          {t('algo.ptcp.txt-Active-sell-vol')}
        </span>
        <span className="fz-12 fw-500 d">{`${formatVolume10(
          !!topShow.length ? topShow[0].TotalSellVolume / 10 : 0
        )}  `}</span>
        <span className="fz-12 fw-500 d ml-2">{t('algo.ptcp.txt-S')}</span>
      </div>
    </>
  )
}

const makeMapStateToProps = () => {
  const getAnalSTMBActive = makeGetAnalSTMBActive()

  const mapStateToProps = (state) => {
    return {
      analStMBActive: getAnalSTMBActive(state),
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps)(memo(PanelStockTradeHistory))
